import React from "react";

interface AlertProps {
    children: React.ReactNode;
    open: boolean
}

const AlertBox: React.FC<AlertProps> = ({
    children,
    open
}) => {
    if (!open) {
        return <></>;
      }
      return (
        <div className="fixed inset-0 z-40 overflow-auto bg-back-shadow flex border-2">
          <div className="relative p-8 bg-white w-full max-w-fit m-auto flex-col shadow-xl flex rounded-lg">
            <div>{children}</div>
         </div>
       </div>
     );
        
}

export default AlertBox